import React, { Fragment, useEffect, useState } from "react";
import { Spin } from "antd";
import moment from "moment";
import { CLIENTS_LIST } from "../../../configs/constants";
import { fetchVisitsOfPdc, fetchClients } from "../api";

const LastVisits = ({ pdcId, token }) => {
  const [loading, setIsLoading] = useState(false);
  const [clients, setClients] = useState(CLIENTS_LIST);
  const [lastVisits, setLastVisits] = useState([]);
  const fetchVisits = async () => {
    setIsLoading(true);

    const visits = await fetchVisitsOfPdc({ token, pdcId });
    const clients = await fetchClients({ token });

    setLastVisits(visits);
    setClients(clients);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchVisits();
  }, [pdcId]);

  return (
    <Fragment>
      <div className="p-pdc-detail-last-title">Dernières visites</div>
      <div className="p-flex-col">
        {loading && <Spin></Spin>}
        {!loading &&
          lastVisits.map(visit => {
            const client = clients.find(client => client.idClient === visit.client_id);
            const clientLabel = client ? client.label : visit.client_label;
            const dateDisplayed = visit.startDate ? moment(visit.startDate).format("DD-MM-YYYY") : "non renseigné";
            return (
              <div key={visit._id}>
                <b>{clientLabel}</b>
                <span>{` : ${dateDisplayed}`}</span>
                <br />
                <br />
              </div>
            );
          })}
      </div>
    </Fragment>
  );
};

export default LastVisits;



// WEBPACK FOOTER //
// src/pages/basepdc/detailPdc/LastVisits.detailpdc.js